import './SettingGroup.less';

import classnames from 'classnames';
import React from 'react';

const SettingGroup = ({
  title,
  children,
  className,
}: {
  title: string;
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={classnames('setting-group', className || '')}>
      {title ? <div className="setting-group-title">{title}</div> : null}
      {children}
    </div>
  );
};

export default SettingGroup;
